import React from 'react';
import {
  LeftNavPane,
  AI_AGENTS_MAP,
  withErrorBoundary,
  getTranslatedText
} from '@nile/components';
import { MONICA_AI_VIEWS } from '@nile/mangifera/src/Constants/workspace';
import { getEmoji } from '@nile/mangifera/src/Pebbles/Views';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';
import { useIntl } from 'react-intl';

const MonicaAIWorkspaceViews = ({ handleClick }) => {
  const intl = useIntl();
  const aiFeatureHook = AIFeaturesHook();
  const isPathAgentAuthorised = aiFeatureHook?.getIsAIFeatureEnabled(
    AI_AGENTS_MAP.PATCH_AGENT
  );
  const isTriageAuthorised = aiFeatureHook?.getIsAIFeatureEnabled(
    AI_AGENTS_MAP.TICKET_TRIAGE
  );

  const onClick = (item) => {
    if (handleClick) {
      handleClick(item);
    }
  };

  if (isPathAgentAuthorised || isTriageAuthorised) {
    return (
      <LeftNavPane.Section
        header={
          <LeftNavPane.SectionHeader
            text={getTranslatedText(intl, 'common.MonicaAI')}
          />
        }
      >
        {MONICA_AI_VIEWS.map((item) => {
          const translatedLabel = getTranslatedText(intl, item.lokaliseKey);
          return (
            <LeftNavPane.LinkItem
              key={item.id}
              emoji={getEmoji(item)}
              text={translatedLabel}
              to={`/monica-ai/${item.id}/list`}
              onClick={() => onClick(item)}
            />
          );
        })}
      </LeftNavPane.Section>
    );
  }
  return <></>;
};

export default withErrorBoundary(MonicaAIWorkspaceViews);
